import { IconButton, Tooltip } from '@mui/material';
import { lookupBrand, fallbackEntry } from './brandIconRegistry';

type Props = {
  type: string;
  value: string;
};

export const BrandIconLink = ({ type, value }: Props) => {
  const trimmedValue = value?.trim() ?? '';
  if (!trimmedValue) return null;

  const entry = lookupBrand(type) ?? fallbackEntry(type || 'Link');
  const href = entry.buildHref(trimmedValue);
  // buildHref returns '' when the value has a dangerous scheme (javascript:,
  // data:, etc.) or contains mail-header-injection characters — never render
  // a clickable link in those cases.
  if (!href) return null;
  const isMailto = href.startsWith('mailto:');
  const { Icon, label } = entry;

  return (
    <Tooltip title={label} arrow>
      <IconButton
        component="a"
        href={href}
        aria-label={label}
        {...(isMailto ? {} : { target: '_blank', rel: 'noopener noreferrer' })}
        size="medium"
        sx={{ color: 'text.primary' }}
      >
        <Icon fontSize="medium" />
      </IconButton>
    </Tooltip>
  );
};
